module.exports = __webpack_public_path__ + "img/news.0c745195.png";